export enum PP_3474_SplitFeatureFlags_Treatments {
  NO_AGENT_RECOMMENDATIONS = 'treatment-A',
  REQUIRED_SELECTION_AGENT_RECOMENDATIONS = 'treatment-B',
  OPTIONAL_SELECTION_AGENT_RECOMMENDATIONS = 'treatment-C',
}

// Add the split feature flags for A/B test in the enum object
// for example: RDP375 = RDP-375_FeaturedAgencies_BackgroundColor, RDP375 is the split name that creating on split.io, only when at least one split exists will send the request to split.io
// Can't be deleted
export enum SplitFeatureFlags {
  DD4533_NEW_TOP_LEVEL_NAVIGATION = 'DD-4533-new-top-level-navigation',
  DD4035_NAVIGATION_EXPERIMENT = 'DD-4035-Alternate-Header-Navigation-Links',
  PP_3365_HOW_LP_NEW_HERO_SECTION = 'PP-3365_how-lp-new-hero-section',
  DD4232_EMPTY_STATE = 'DD-4232-Empty-State-AB-Test',
  PP_3474 = 'PP-3474_show-agents-recommendation',
}
